import { api } from "../../Shared/methods/ajax/axios_instance"

export default () => api.get("/get_paypal_config")